export enum WEBSOCKET_EVENT {
  UPDATE_SUBSCRIPTION = "update_subscription",
  PUSH_NOTIFICATION = "push_notification",
  DISABLED_USER = "disabled_user",
  DISABLED_COMPANY = "disabled_company",
  DISABLED_OWNER = "disabled_owner",
  HEALTH = "health",
  WHATSAPP_NOTIFICATION = "whatsapp_notification",
  WHATSAPP_CHAT = "whatsapp_chat", // evento para chat de WA
  BULK_SENT_NOTIFICATION = "bulk_sent_notification",
  LOADED_FILE = "loaded_file",
  FILE_NOTIFICATION = "file_notification",
}
